var map = {
	"./africa/ca-cdf.png": 2028,
	"./africa/cdn-cdf.png": 3914,
	"./africa/cdn-critical-rank.png": 4051,
	"./africa/cdn-critical-vantage.png": 634,
	"./africa/cdn-dependency.png": 2952,
	"./africa/cdn-usage.png": 4193,
	"./africa/dns-cdf.png": 8323,
	"./africa/dns-critical-rank.png": 4895,
	"./africa/dns-critical-vantage.png": 9445,
	"./africa/dns-dependency.png": 531,
	"./africa/dns-redundant-rank.png": 9040,
	"./africa/https-usage.png": 8840,
	"./africa/ke-venn.png": 8101,
	"./africa/ng-venn.png": 1441,
	"./africa/ocsp-critical-rank.png": 4601,
	"./africa/ocsp-critical-vantage.png": 4845,
	"./africa/ocsp-dependency.png": 1902,
	"./africa/rw-venn.png": 496,
	"./africa/za-venn.png": 6241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1036;